export default __webpack_public_path__ + "static/media/Group 1675.b1bd75ce.svg";